<template>
  <b-row class="my-4 project-title-detail">
    <!--v-if="summary"-->
    <b-col cols="5">
      <!--<div class="back-to">
                <b-button href="/projects" class="return-project">
                  <b-icon icon="chevron-left"></b-icon>Back to Projects
                </b-button>
      </div>-->
      <h1 class="title project">
        <span v-if="meetingName">{{ meetingName }} | </span>
        <span :class="{ 'font-weight-light': isMeeting }">{{ projectName }}</span>
      </h1>
      <div class="project-specs">
        <p>
          <strong>Resident Engineer</strong>
          : {{ residentEngineer || residentEngineerTitle }}
        </p>
        <p>
          <strong>Project Manager</strong>
          : {{ projectManager || projectManagerTitle }}
        </p>
        <p v-if="facilitatorName">
          <strong>Project Manager</strong>
          : {{ facilitatorName || facilitatorNameTitle }}
        </p>
      </div>
    </b-col>
    <b-col offset="1" cols="6">
      <div v-if="viewProjectBtn" class="align-right" style="margin-bottom: 20px">
        <b-button variant="primary" :to="'/project/' + projectId">View Project</b-button>
      </div>
      <b-row align-h="end">
        <b-col v-if="organizationLogo" cols="auto">
          <div class="company-logo-wrapper">
            <div class="widget logo-container">
              <img :src="organizationLogo" class alt="Owner Logo" />
            </div>
          </div>
        </b-col>
        <b-col v-if="contractorLogo" cols="auto">
          <div class="company-logo-wrapper">
            <div class="widget logo-container">
              <img :src="contractorLogo" class alt="Contractor Logo" />
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "ProjectDetails",
  props: {
    projectName: {
      type: String,
      default: "",
    },
    meetingName: {
      type: String,
      default: "",
    },
    projectUsers: {
      type: Array,
      default: () => [],
    },
    residentEngineer: {
      type: String,
      default: "",
    }, // Overrides Project Users filters
    projectManager: {
      type: String,
      default: "",
    }, // Overrides Project Users filters
    facilitatorName: {
      type: String,
      default: "",
    }, // Overrides Project Users filters
    projectId: {
      type: String,
      default: "",
    },
    organizationLogo: {
      type: String,
      default: "",
    },
    contractorLogo: {
      type: String,
      default: "",
    },
    viewProjectBtn: {
      type: Boolean,
      default: false,
    },
    projectSummary: {
      type: Object,
    },
  },
  computed: {
    residentEngineerTitle() {
      let residentEngineers = this.projectUsers.filter(
        (p) => p.role === "Owner" && p.permissionLevel === "Admin"
      );
      return residentEngineers.map((r) => r.name).join(", ");
    },
    projectManagerTitle() {
      let projectManagers = this.projectUsers.filter(
        (p) => p.role === "Contractor" && p.permissionLevel === "Admin"
      );
      return projectManagers.map((p) => p.name).join(", ");
    },
    facilitatorNameTitle() {
      return this.projectUsers.find((p) => p.role === "Facilitator");
    },
    isMeeting() {
      return this.meetingName.length > 0;
    }
  },
};
</script>

<style lang="scss" scoped>
</style>